module.exports = __webpack_public_path__ + "img/bg-geras-construtcion.b1789268.png";